import { render, staticRenderFns } from "./cancelForm.vue?vue&type=template&id=28078d4e&scoped=true&"
import script from "./cancelForm.vue?vue&type=script&lang=js&"
export * from "./cancelForm.vue?vue&type=script&lang=js&"
import style0 from "./cancelForm.vue?vue&type=style&index=0&id=28078d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28078d4e",
  null
  
)

export default component.exports